// Native-only: survives Android killing the WebView renderer while the app is
// backgrounded. When that happens MainActivity recreates the activity (fresh
// WebView, app cold-boots); this localStorage mark lets the app navigate back
// to the CV builder and reopen the preview exactly where the user left off.
import { Capacitor } from '@capacitor/core';

const KEY = 'wassla_cv_preview_restore';
const MAX_AGE_MS = 15 * 60 * 1000;

export function markCvPreviewOpen() {
  if (!Capacitor.isNativePlatform()) return;
  try { localStorage.setItem(KEY, String(Date.now())); } catch (_e) { /* noop */ }
}

export function clearCvPreviewMark() {
  try { localStorage.removeItem(KEY); } catch (_e) { /* noop */ }
}

export function hasFreshCvPreviewMark() {
  if (!Capacitor.isNativePlatform()) return false;
  try {
    const ts = Number(localStorage.getItem(KEY));
    return Boolean(ts) && Date.now() - ts < MAX_AGE_MS;
  } catch (_e) {
    return false;
  }
}
